import { render, staticRenderFns } from "./buy-cursos.vue?vue&type=template&id=2311b0f9&scoped=true"
import script from "./buy-cursos.vue?vue&type=script&lang=js"
export * from "./buy-cursos.vue?vue&type=script&lang=js"
import style0 from "./buy-cursos.vue?vue&type=style&index=0&id=2311b0f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311b0f9",
  null
  
)

export default component.exports